import styled from '../../../theme/styled-with-theme';
import { pxToRem } from '../../../styles/utils';

import { TextInputWidth } from '../shared';

import arrowDown from '@/images/arrow-down.svg';

export const TextInputWrapper = styled('div')<{
  width: TextInputWidth;
  error: boolean;
  variant: string;
}>`
  padding: 0px;
  width: ${({ width }) => width}%;
  border: 1px solid
    ${({ theme, error }) =>
      error ? theme.color.textInputInvalid : theme.color.textInputPrimary};
  border-radius: ${({ theme }) => theme.borderRadius.input_desktop};
  margin-bottom: ${({ error }) => (error ? '8px' : '16px')};
  transition: border 0.3s, margin-bottom 0.3s;

  ${({ variant }) => {
    switch (variant) {
      case 'filterbar':
        return `
          border-radius: 100px;
          height: 32px;
          margin-bottom: 0;
        `;
      default:
        return ``;
    }
  }}
`;

export const InputLabel = styled('label')<{
  floatLabel: boolean;
  variant: string;
}>`
  position: absolute;
  transition: margin-top 0.3s, font-size 0.3s, margin-left 0.3s, padding 0.3s;
  border-radius: ${({ theme }) => theme.borderRadius.input_desktop};
  font-weight: 500;
  font-size: ${({ floatLabel }) => (floatLabel ? '.8em' : '1em')};
  padding: ${({ floatLabel }) =>
    floatLabel ? '0 4px 0 4px' : `${pxToRem(22)} 0 0 ${pxToRem(16)}`};
  ${({ floatLabel }) =>
    floatLabel
      ? `
      margin-top: -8px;
      margin-left: 16px;
      background-color: #fff;
    `
      : ''}

  ${({ variant, theme, floatLabel }) => {
    switch (variant) {
      case 'filterbar':
        return `
          font-weight: ${theme.fontWeight[400]};
          font-size: ${theme.fontSize.sm};
          color: ${theme.color.secondaryText};
          padding: ${pxToRem(6)} ${pxToRem(16)};
          ${
            floatLabel &&
            `
              margin: 0;
              visibility: hidden;
            `
          }
        `;
      case 'selectstate':
        return `
          ${
            floatLabel &&
            `
              margin: 0;
              visibility: hidden;
            `
          }
        `;
      default:
        return '';
    }
  }}
`;

export const SelectInput = styled('select')<{ variant: string }>`
  border: none;
  height: ${pxToRem(64)};
  width: 100%;
  border-radius: ${({ theme }) => theme.borderRadius.input_desktop};
  padding: ${pxToRem(22)} ${pxToRem(16)};
  color: ${({ theme }) => theme.color.black};
  line-height: 1.5;
  -moz-appearance: none;
  -webkit-appearance;
  appearance: none;
  background-image: url(${arrowDown.src});
  background-color: ${({ theme }) => theme.color.white};
  background-repeat: no-repeat;
  background-position: calc(100% - ${pxToRem(22)}) center;
  background-size: ${pxToRem(12)};

  &:focus {
    outline: none;
  }

  ${({ variant }) => {
    switch (variant) {
      case 'filterbar':
        return `
          height: 30px;
          border-radius: 100px;
          padding: 0px 16px;
          box-sizing: border-box;
        `;
      default:
        return ``;
    }
  }}
`;

export const ErrorMessage = styled('div')<{
  visible: boolean;
  variant: string;
}>`
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.color.textInputInvalid};
  max-height: ${({ visible }) => (visible ? '24px' : '0')};
  opacity: ${({ visible }) => (visible ? '1' : '0')};
  margin-bottom: ${({ visible }) => (visible ? '16px' : '0')};
  -webkit-transition: max-height 0.3s, opacity 0.3s, padding 0.3s,
    margin-bottom 0.3s;
  -moz-transition: max-height 0.3s, opacity 0.3s, padding 0.3s,
    margin-bottom 0.3s;
  -ms-transition: max-height 0.3s, opacity 0.3s, padding 0.3s,
    margin-bottom 0.3s;
  -o-transition: max-height 0.3s, opacity 0.3s, padding 0.3s, margin-bottom 0.3s;
  transition: max-height 0.3s, opacity 0.3s, padding 0.3s, margin-bottom 0.3s;
  overflow: hidden;

  ${({ variant }) => {
    switch (variant) {
      case 'filterbar':
        return `
          display: none;
        `;

      default:
        return ``;
    }
  }}
`;

export const IconWrapper = styled('div')`
  margin-left: 16px;
  margin-right: 8px;
  height: 100%;
  display: flex;
`;
